import Cookies from 'js-cookie'

import { PostalDeliveryState } from '../types'

import {
  COOKIE_DELIVERY_AREA_CITY,
  COOKIE_DELIVERY_AREA_POSTAL_CODE,
  COOKIE_SUPPORTED_POSTAL_CODE
} from './keys'

/** The delivery area and whether it is served, kept for the browser session. */
export class DeliverySupportCookies {
  static set = ({
    postalCode,
    city,
    isSupported
  }: Pick<PostalDeliveryState, 'postalCode' | 'city' | 'isSupported'>) => {
    Cookies.set(COOKIE_DELIVERY_AREA_POSTAL_CODE, postalCode)
    Cookies.set(COOKIE_DELIVERY_AREA_CITY, city)
    Cookies.set(COOKIE_SUPPORTED_POSTAL_CODE, isSupported ? 'true' : 'false')
  }

  static get() {
    return {
      postalCode: Cookies.get(COOKIE_DELIVERY_AREA_POSTAL_CODE) || null,
      city: Cookies.get(COOKIE_DELIVERY_AREA_CITY) || null,
      isSupported: Cookies.get(COOKIE_SUPPORTED_POSTAL_CODE) === 'true'
    }
  }

  static remove(): void {
    Cookies.remove(COOKIE_DELIVERY_AREA_POSTAL_CODE)
    Cookies.remove(COOKIE_DELIVERY_AREA_CITY)
    Cookies.remove(COOKIE_SUPPORTED_POSTAL_CODE)
  }
}
